export default __webpack_public_path__ + "static/media/tealeaf-left-bottom.e19c1919.png";